/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Misfit_1Inputs */

const en_pc_alt_misfit_1 = /** @type {(inputs: Pc_Alt_Misfit_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reliable editing of existing text, especially Chinese, Japanese, Korean and right-to-left scripts.`)
};

const zh_pc_alt_misfit_1 = /** @type {(inputs: Pc_Alt_Misfit_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可靠地编辑已有文字，尤其是中文、日文、韩文和从右到左书写的文字。`)
};

/**
* | output |
* | --- |
* | "Reliable editing of existing text, especially Chinese, Japanese, Korean and right-to-left scripts." |
*
* @param {Pc_Alt_Misfit_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_misfit_1 = /** @type {((inputs?: Pc_Alt_Misfit_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Misfit_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_misfit_1(inputs)
	return zh_pc_alt_misfit_1(inputs)
});
export { pc_alt_misfit_1 as "pc.alt.misfit.1" }